import Axios from 'axios';
import keycloak from '../tools/keycloak';

class Comm {

    instance = null;
    instanceForSis = null;
    instanceForImage = null;

    url = "";
    sisUrl = "";

    constructor() {
        this.url = "/";
        this.sisUrl = process.env.REACT_APP_API;


        //process.env.NODE_ENV.toLowerCase() === "development" ? "https://localhost:5001/api/" : "http://172.16.0.57:8080/api/";
        //this.url = process.env.NODE_ENV.toLowerCase() === "development" ? "https://www.justice.government.bg/api/" : "http://172.16.0.57:8080/api/";
    }

    Instance(slow = false) {

        console.log("keycloak", keycloak);
        if (this.instance === null) {

            this.instance = Axios.create({
                baseURL: this.url,
                headers: { 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " + keycloak.token },
                timeout: slow ? 60000 : 10 * 60 * 1000
            });


        }
        return this.instance;
    }

    InstanceForSis() {


        if (this.instanceForSis === null) {

            this.instanceForSis = Axios.create({
                baseURL: this.sisUrl,
                headers: { 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " + keycloak.token }
            });


        }
        return this.instanceForSis;
    }

    InstanceForImage() {

        if (this.instanceForImage === null) {

            this.instanceForImage = Axios.create({
                baseURL: this.url,
                headers: { 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " + keycloak.token, 'Content-Type': 'multipart/form-data' },
                timeout: 10 * 60 * 1000
            });


        }
        return this.instance;
    }

}

export default new Comm();